module.exports = (__webpack_require__(0))(135);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/ItemView.js from dll-reference girder_lib
// module id = 10
// module chunks = 0